import { render, staticRenderFns } from "./registeringMember.vue?vue&type=template&id=2d7f9822&scoped=true&"
import script from "./registeringMember.vue?vue&type=script&lang=js&"
export * from "./registeringMember.vue?vue&type=script&lang=js&"
import style0 from "./registeringMember.vue?vue&type=style&index=0&id=2d7f9822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7f9822",
  null
  
)

export default component.exports